const FaresReducer = (state, action) => {
    switch (action.type) {

        case "GET_FARES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "GET_FARES_SUCCESS":
            return {
                ...state,
                fares: action.payload,
                isFetching: false,
                error: false,
                hasFetched: true,
            };

        case "GET_FARES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
                hasFetched: false,
            };

        case "CREATE_FARES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "CREATE_FARES_SUCCESS":
            return {
                ...state,
                fares: [...state.fares, action.payload],
                isFetching: false,
                error: false,
            };

        case "CREATE_FARES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        case "UPDATE_FARES_START":
            return {
                ...state,
                isFetching: true,
                error: false,
            };

        case "UPDATE_FARES_SUCCESS":
            return {
                ...state,
                fares: state.fares.map((fare) =>
                    fare._id === action.payload._id
                        ? action.payload
                        : fare
                ),
                isFetching: false,
                error: false,
            };

        case "UPDATE_FARES_FAILURE":
            return {
                ...state,
                isFetching: false,
                error: true,
            };

        default:
            return state;
    }
};

export default FaresReducer;